/** 能源 — 用水桑基图 /energy/water-sankey（waterSankey.vue） */
export default {
  waterSankey: {
    filterQueryDate: '查询日期',
    phPickDate: '选择日期',
    filterTenantScope: '租户范围',
    phTenant: '请选择租户',
    btnQuery: '查询',
    btnReset: '重置',
    btnSelectAll: '全选',
    btnDeselectAll: '取消全选',
    cardTotalWater: '总用水量',
    cardTotalWaterTip: '所有租户当日总用水量',
    comingSoon: '功能开发中',
    cardTenantCount: '租户数量',
    unitTenants: '户',
    selectedTenants: '已选租户',
    cardAvgWater: '平均用水',
    unitM3PerTenant: 'm³/户',
    cardDistribution: '用水分布',
    byTypeDistribution: '按类型分布',
    dataInDevelopment: '数据开发中',
    loading: '数据加载中...',
    chartTitle: '用水流向分析',
    chartSubtitle: '{date} 租户用水分布桑基图',
    tipDeveloping: '该功能正在开发中，敬请期待',
    emptyTitle: '功能开发中',
    emptyDescription: '用水桑基图功能正在开发中，将为您提供完整的用水流向分析',
    featureFlow: '直观的用水流向展示',
    featureDevice: '详细的设备用水分析',
    featureCompare: '租户用水对比统计',
    btnComingSoon: '敬请期待',
    pickerYesterday: '昨天',
    pickerDayBefore: '前天',
    pickerMondayThisWeek: '本周一',
    pickerLastMonday: '上周一',
    msgTenantListFail: '获取租户列表失败',
    msgPickDate: '请选择查询日期',
    msgPickTenant: '请选择租户',
    msgFeatureDeveloping: '该功能正在开发中'
  }
}
